import { motion } from "framer-motion";
import { ListChecks, Truck, Rocket } from "lucide-react";
import { useT } from "@/i18n";

const icons = [ListChecks, Truck, Rocket];
const containerVariants = { hidden: {}, visible: { transition: { staggerChildren: 0.15 } } };
const itemVariants = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0, transition: { duration: 0.5 } } };

export default function HowItWorks() {
  const t = useT();
  const h = t.howItWorks;

  return (
    <section id="como-funciona" data-testid="how-it-works-section" className="py-24 sm:py-32 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }} className="text-center mb-16">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-orange-400 mb-4">{h.overline}</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-white">{h.title}</h2>
        </motion.div>
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {h.steps.map((step, index) => {
            const Icon = icons[index];
            return (
              <motion.div key={index} variants={itemVariants} data-testid={`step-card-${index}`} className="relative glass-card rounded-3xl p-8 sm:p-10 text-center group">
                <div className="absolute top-6 right-8 text-7xl font-bold text-white/[0.03] select-none">{String(index + 1).padStart(2, "0")}</div>
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-orange-500/20 to-red-500/10 border border-orange-500/20 flex items-center justify-center mx-auto mb-6 group-hover:scale-105 transition-transform">
                  <Icon className="w-7 h-7 text-orange-400" strokeWidth={1.5} />
                </div>
                <h3 className="text-xl sm:text-2xl font-medium tracking-tight text-white mb-3">{step.title}</h3>
                <p className="text-sm sm:text-base text-slate-400 leading-relaxed">{step.desc}</p>
                {index < 2 && <div className="hidden md:block absolute top-1/2 -right-4 sm:-right-4 w-8 h-px bg-gradient-to-r from-orange-500/40 to-transparent" />}
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
